import type {
    IStekzSchema,
    IStekzFieldProperties,
    IFields,
} from "@/wc/registry/lib/service/repository/types";
import { get } from "lodash";

// Use the repository properties to figure out a nice way of displaying the passed data.
export default function format(
    fieldName: string,
    fieldsOrValue: IFields,
    _repositoryProperties: IStekzSchema | IStekzFieldProperties
) {
    return get(fieldsOrValue, fieldName);
}
